import { Action } from '../../common/actions/core/action';
import { CancelSubscriptionType, PackageThumbnail } from '../../common/services/package/package.model';

export class CancelSubscriptionAction implements Action {
  constructor(
    public onDeleteSuccess: (type: CancelSubscriptionType) => void,
    public packet: PackageThumbnail,
    public msisdnTr?: string,
    public masterCardName?: string
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/cancel-subscription-dialog/cancel-subscription-dialog.action.ts